import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { NeedHelpInitStepDeclaration } from "./Steps/NeedHelpSteps";

export const needHelpStartupFlow = new FlowDefinition("NeedHelpFlow");

needHelpStartupFlow.addStep(NeedHelpInitStepDeclaration);
needHelpStartupFlow.setStartStep("NeedHelpInit_Step");

export const needHelpStartupFlowDefinition = new StepDefinition({
    stepName: "NeedHelpFlow",
    stepFlow: needHelpStartupFlow,
    contextIsolation: false
})